import includes from 'lodash/includes';
import { CIBuildFeatures } from '@Constants/CommonConstants';

// eslint-disable-next-line import/prefer-default-export
export function isBuildFeatureEnabled(feature) {
  return includes(CIBuildFeatures, feature);
}
